import { PeriodEndPage } from '@/pages/shared/period-end';

export function TradingPeriodEndPage() {
  return <PeriodEndPage app="TRADING" />;
}
